import { render, staticRenderFns } from "./warranty-order-list.vue?vue&type=template&id=853db256&lang=pug&"
import script from "./warranty-order-list.vue?vue&type=script&lang=js&"
export * from "./warranty-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports